module.exports = __webpack_public_path__ + "img/XSGL.8dcee085.png";